import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ---------------- AUTH CHECK ----------------
  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (!token) {   
      navigate("/admin-login");
    } else {
      loadBookings();
    }
  }, []);

  // ---------------- LOAD BOOKINGS ----------------
  async function loadBookings() {
    try {
      const res = await fetch("https://enteai-web-lj55.vercel.app/api/admin/bookings", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      });

      const data = await res.json();
      setBookings(data);
    } catch (error) {
      console.error("Error loading bookings:", error);
    } finally {
      setLoading(false);
    }
  }

  // ---------------- UPDATE STATUS (APPROVE/REJECT) ----------------
  async function updateStatus(id, action) {
    try {
      const res = await fetch(
        `https://enteai-web-lj55.vercel.app/api/booking/${id}/${action}`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("adminToken"),
          },
        }
      );

      if (!res.ok) {
        alert("Error updating status");
        return;
      }

      loadBookings();
    } catch (error) {
      console.error("Update error:", error);
      alert("Error updating status");
    }
  }

  // ---------------- SEND RESCHEDULE EMAIL ----------------
  async function sendReschedule(id) {
    try {
      const res = await fetch(
        `https://enteai-web-lj55.vercel.app/api/booking/${id}/reschedule`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("adminToken"),
          },
        }
      );

      if (!res.ok) {
        alert("Error sending reschedule mail");
        return;
      }

      alert("Reschedule email sent!");
      loadBookings();
    } catch (error) {
      console.error("Reschedule error:", error);
      alert("Error sending reschedule mail");
    }
  }

  // ---------------- STYLES ----------------
  const badgeStyle = (status) => {
    switch (status) {
      case "approved":
        return { background: "#4CAF50" };
      case "rejected":
        return { background: "#E53935" };
      case "rescheduled":
        return { background: "#FFC107", color: "black" };
      default:
        return { background: "#7E57C2" };
    }
  };

  const buttonStyle = (bg, text = "#fff") => ({
    backgroundColor: bg,
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    color: text,
    fontWeight: "bold",
    transition: "0.2s",
    width: "120px",
    textAlign: "center",
    fontSize: "14px",
    boxShadow: "0px 0px 8px rgba(0,0,0,0.25)",
  });

  // ---------------- LOADING SCREEN ----------------
  if (loading) {
    return (
      <h2 style={{ color: "white", textAlign: "center", marginTop: "20px" }}>
        Loading...
      </h2>
    );
  }

  // ---------------- RENDER DASHBOARD ----------------
  return (
    <div style={{ padding: "30px", color: "white" }}>
      <h1 style={{ marginBottom: "15px" }}>Admin Dashboard</h1>
      <p style={{ opacity: 0.7 }}>Manage all project booking requests</p>

      {/* GRID: 3 CARDS PER ROW */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
          marginTop: "30px",
        }}
      >
        {bookings.map((b) => {
          const normalizedStatus = b.status?.trim().toLowerCase() || "pending";

          return (
            <div
              key={b._id}
              style={{
                background: "#1E2432",
                padding: "25px",
                borderRadius: "10px",
                border: "1px solid #2D3445",
                display: "flex",
                flexDirection: "column",
                minHeight: "350px",
              }}
            >
              <h3 style={{ marginBottom: "10px", fontSize: "22px" }}>
                {b.name}
              </h3>

              <p>
                <b>Project:</b> {b.projectTitle}
              </p>
              <p>
                <b>Date:</b> {b.date}
              </p>
              <p>
                <b>Slot:</b> {b.slot}
              </p>
              <p>
                <b>Notes:</b> {b.notes || "—"}
              </p>

              {/* STATUS BADGE */}
              <div
                style={{
                  marginTop: "15px",
                  display: "inline-block",
                  padding: "8px 14px",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  ...badgeStyle(normalizedStatus),
                  width: "fit-content",
                }}
              >
                {normalizedStatus.toUpperCase()}
              </div>

              {/* ACTION BUTTONS */}
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {/* SHOW APPROVE/REJECT ONLY WHEN PENDING */}
                {normalizedStatus === "pending" && (
                  <>
                    <button
                      onClick={() => updateStatus(b._id, "approve")}
                      style={buttonStyle("#4CAF50")}
                    >
                      Approve
                    </button>

                    <button
                      onClick={() => updateStatus(b._id, "reject")}
                      style={buttonStyle("#E53935")}
                    >
                      Reject
                    </button>
                  </>
                )}

                {/* RESCHEDULE ALWAYS VISIBLE */}
                <button
                  onClick={() => sendReschedule(b._id)}
                  style={buttonStyle("#FFC107", "black")}
                >
                  Reschedule
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
